module.exports = {"430903001":"赫山街道","430903002":"桃花仑街道","430903003":"金银山街道","430903006":"会龙山街道","430903007":"鱼形山街道","430903008":"龙光桥街道","430903101":"八字哨镇","430903103":"泉交河镇","430903104":"欧江岔镇","430903105":"沧水铺镇","430903107":"岳家桥镇","430903110":"新市渡镇","430903111":"兰溪镇","430903113":"衡龙桥镇","430903114":"泥江口镇","430903209":"笔架山乡","430903402":"龙岭产业开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430903.json
// module id = 2010
// module chunks = 0